/**
 * UAVTradeZone Modification Record
 *
 * Change ID:    TOOLTIP_CONSTANTS_BROADCAST
 * Date:         2026-01-27
 * Modified By:  Cursor
 *
 * Description:
 * Tooltip definitions for broadcast fields.
 *
 * File Size Check:
 * - Current: 0 (new file)
 * - Adding: ~50 lines
 * - Projected: 50 lines
 * - Decision: Proceed
 *
 * Related Files:
 * - client/src/components/broadcast/BroadcastItemCard.tsx
 */

export const BROADCAST_TOOLTIPS = {
  TYPE: "Want to buy (WTB) or want to sell (WTS)",
  MANUFACTURER: "Manufacturer or brand of the UAV part",
  PART_NUMBER: "Manufacturer's product identifier (part Number or SKU)",
  CATEGORY: "Product category (for example: drones, batteries, motor, etc.)",
  CONDITION: "Item condition (NEW Retail, NEW Bulk, Used, Refurbished, As-is)",
  QUANTITY: "Quantity: number of units available or requested",
  PRICE: "Cost per unit in selected currency",
  TIME_POSTED: "When this broadcast was created",
  COMPANY: "The company or organization that posted this broadcast",
  DESCRIPTION: "Additional product details and notes",
  TITLE: "Broadcast title: product name or identifier",
} as const;

/**
 * UAVTradeZone Modification Record
 *
 * Change ID:    TOOLTIP_CONSTANTS_ACTION_BUTTONS
 * Date:         2026-01-27
 * Modified By:  Cursor
 *
 * Description:
 * Added tooltips for action buttons and controls.
 *
 * File Size Check:
 * - Current: 150 lines
 * - Adding: ~40 lines
 * - Projected: 190 lines
 * - Decision: Proceed
 *
 * Related Files:
 * - client/src/components/inventory/InventoryItemCard.tsx
 * - client/src/components/inventory/InventoryFilters.tsx
 * - client/src/components/broadcast/BroadcastFilters.tsx
 * - client/src/features/inventory/inventory-page/components/InventoryHeader.tsx
 */

export const ACTION_BUTTON_TOOLTIPS = {
  // Inventory item actions
  EDIT_ITEM: "Edit this item's details",
  DELETE_ITEM: "Remove this item from your inventory",
  
  // Inventory header actions
  ADD_ITEM: "Add a new inventory item",
  UPLOAD_FILE: "Upload inventory from CSV or Excel file",
  DOWNLOAD_TEMPLATE: "Download inventory template file",
  MY_INVENTORY: "Download your complete inventory",
  
  // Filter controls
  CLEAR_FILTERS: "Reset all filters to show all items",
  COLLAPSE_FILTERS: "Hide filter panel",
  EXPAND_FILTERS: "Show filter panel",
  
  // Sort controls
  SORT_INVENTORY: "Change the order items are displayed",
  SORT_SEARCH: "Change the order search results are displayed",
} as const;
